import React, { useEffect, useState } from "react";
import './CustomerDashboard.css';
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/shared/loader/Loader";
import ErrorPage from "../../../components/shared/errorPage/ErrorPage";
import { ResetUserFeedback } from "../../../actions/Dashboard";
import Dashboard from "./Dashboard/Dashboard";
import { removeNativeAppStorageItems } from "../../../constants/AppMethod";

const CustomerDashboard = () => {
  const dispatch = useDispatch();
  const userEnrolledDeviceResponse = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);
  const [isRedirectToDashboard, setIsRedirectToDashboard] = useState(false);

  useEffect(() => {
    setIsRedirectToDashboard(true);

    dispatch(ResetUserFeedback());
    removeNativeAppStorageItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (userEnrolledDeviceResponse.userDeviceList_loading) {
    return <Loader />;
  }

  if (userEnrolledDeviceResponse.userDeviceList_error) {
    return <ErrorPage errorInfo={userEnrolledDeviceResponse.userDeviceList_error}></ErrorPage>
  }

  return (
    <>
      {
        (isRedirectToDashboard && userEnrolledDeviceResponse.userDeviceList_success)
          ? <Dashboard />
          : <Loader />
      }
    </>
  )
}

export default CustomerDashboard;